// import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import DorisLogo from "../images/DORIS@2x.svg"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#002c4a`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1rem 1.0875rem`,
      }}
    >
        <a
          href="https://doris.evisions.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mb-0"
        >
          <img src={DorisLogo} alt="DORIS Logo" />
        </a>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
